export default {
  'portal.embed.noUrlProvided': 'No se proporcionó una URL de plantilla.',
  'portal.embed.notFound': 'No se encontró la plantilla solicitada.',
};
